import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RefundRequestSuccessComponent } from 'src/app/Product/refund-request-success/refund-request-success.component';
import { PaymentService } from 'src/app/_services/payment.service';
import { AlertService } from 'src/app/_alert';
import { RefundService } from 'src/app/_services/refund.service';

@Component({
  selector: 'app-refund-amount',
  templateUrl: './refund-amount.component.html',
  styleUrls: ['./refund-amount.component.css']
})
export class RefundAmountComponent implements OnInit {
  
  isSubmitted: boolean = false;
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<RefundAmountComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    public paymentService: PaymentService,
    public alertService: AlertService,
    public refundService : RefundService) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.isSubmitted = true;
    this.refundService.raiseRefund(this.data.refundData).subscribe((response: any) => {
      console.log(response);
      if (response.responseDescription == null) {
        const dialogRef = this.dialog.open(RefundRequestSuccessComponent, {
          width: '500px',
          disableClose: true,
          data: { data: this.data.refundData, response: response.refundIdentifier }
        });
        this.dialogRef.close();
        this.isSubmitted = false;
      }
      else {
        this.alertService.info(response.responseDescription, this.options);
        this.isSubmitted = false;
      }
    }, (err) => {
      this.alertService.error('error' + err, this.options);
      this.isSubmitted = false;
    })
  }

  close() {
    this.dialogRef.close();
  }
}
